import {message} from "antd";

export const handleCopyClick = async (textToCopy:string) => {
    try {
        await navigator.clipboard.writeText(textToCopy);
        message.success(`복사 되었습니다.`);
    } catch (err) {
        message.error(`복사에 실패했습니다.`);
    }
};